import { createContext, useContext } from 'react';

import { HeadingTagType } from '@lexical/rich-text';
import { ElementFormatType, TextFormatType } from 'lexical';

import { EditorType } from './types';

export type BlockType = 'paragraph' | HeadingTagType | 'bullet' | 'number' | 'check' | 'quote';

export interface ToolbarContextType {
  editorType: EditorType;
  activeTextFormats: Set<TextFormatType>;
  bgColor: string;
  blockType: BlockType;
  canRedo: boolean;
  canUndo: boolean;
  elementFormat: ElementFormatType;
  fontColor: string;

  // codeLanguage: string;
  // fontFamily: string;
  // fontSize: string;
  // fontSizeInputValue: string;
  // isImageCaption: boolean;
  // isLink: boolean;
  // isRTL: boolean;
  // rootType: 'root' | 'table';
}

export const ToolbarContext = createContext<ToolbarContextType | undefined>(undefined);

export function useToolbarContext() {
  const context = useContext(ToolbarContext);

  if (!context) {
    throw new Error('useToolbarContext must be used within a ToolbarContext');
  }

  return context;
}
